import { createSelector } from '@ngrx/store';
import { GlobalState } from './../store';
import { selectCertificate } from './certificate.selector';

export const selectSession = (state: GlobalState) => state.session;
export const selectUserInfo = createSelector(
  selectSession,
  session => session?.userInfo
);

export const isLogged = createSelector(
  selectSession,
  selectCertificate,
  (session, certificate) => !!session?.userInfo || !!session?.urls
);

export const isCertValid = createSelector(
  selectCertificate,
  certificate =>
    !['INVALID', 'NOT_VALID'].includes(certificate?.certificateStatus)
);

export const needsForcePassword = createSelector(
  selectSession,
  session => session?.needsForcePassword
);

export const isPkboxSelector = createSelector(selectSession, session => ({
  isPkBox: !session?.icssUser && !session?.trissUser,
  user: session?.userInfo,
}));

//export const sessionSelector = createSelector<GlobalState, any, any>();
